// Benutzer & Google-Freigaben (nur Admin)
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { UserCheck, Trash2 } from "lucide-react";
import { UserCreateForm } from "./UserCreateForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth/users`;
const ROLE = { admin: "Admin", manager: "Manager", reception_com: "Rezeption", pending: "wartet auf Freigabe" };

export function UserAccess() {
  const [users, setUsers] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => axios.get(API).then((r) => setUsers(r.data)).catch(() => setUsers(false)), []);
  useEffect(() => { load(); }, [load]);
  const act = async (fn) => {
    setErr("");
    try { await fn(); await load(); } catch (e) { setErr(e.response?.data?.detail || "Aktion fehlgeschlagen"); }
  };
  if (users === false || users === null) return null;
  const pending = users.filter((u) => u.role === "pending").length;
  return (
    <div className="card max-w-3xl" data-testid="user-access">
      <div className="overline mb-1 flex items-center gap-2"><UserCheck size={14} /> Benutzer &amp; Google-Anmeldung</div>
      <p className="text-sm text-eb-muted mb-3">
        Neue Google-Konten landen hier und sehen nichts, bis du sie freigibst.{pending > 0 && <b className="text-amber-300"> {pending} wartet auf Freigabe.</b>}
      </p>
      {err && <div className="text-rose-400 text-xs mb-2" data-testid="user-access-error">{err}</div>}
      <div className="space-y-2">
        {users.map((u) => (
          <div key={u.id} className="flex items-center gap-3 eb-surface rounded-md px-3 py-2 border border-white/5" data-testid={`user-row-${u.email}`}>
            {u.picture ? <img src={u.picture} alt="" className="w-7 h-7 rounded-full" /> : <div className="w-7 h-7 rounded-full bg-white/10" />}
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{u.name || u.email}</div>
              <div className="text-[11px] text-eb-muted truncate">{u.email} · {u.provider === "google" ? "Google" : "Passwort"}</div>
            </div>
            <select value={u.role} onChange={(e) => act(() => axios.patch(`${API}/${u.id}`, { role: e.target.value }))}
              className={`!w-auto !text-xs ${u.role === "pending" ? "text-amber-300" : ""}`} data-testid={`user-role-${u.email}`}>
              {Object.entries(ROLE).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
            <button className="text-eb-muted hover:text-rose-400" aria-label="Benutzer löschen" title="Benutzer löschen" data-testid={`user-delete-${u.email}`}
              onClick={() => window.confirm(`${u.email} wirklich löschen?`) && act(() => axios.delete(`${API}/${u.id}`))}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
      <UserCreateForm api={API} onCreated={load} />
    </div>
  );
}
